// Cloud Run APIのエンドポイント
const API_BASE_URL = `${window.location.origin}/api`;

export { API_BASE_URL };